export class ShopifyErrors {

  private errorsObject = {
    failedToConnectToShopifyAPI: false,
    failedToReceiveMainTheme: false,
    failedToReceiveThemeLiquid: false,
    failedToReceiveProductLiquid: false,
    invalidThemeLiquid: false,
    yotpoAlreadyInstalled: false,
    scriptTagInstalled: false,
    noScriptTagPermissions: false
  };

  constructor(private errors: any) {
    this.errorsObject.failedToConnectToShopifyAPI = this.errors.includes('FailedToConnectToShopifyAPI');
    this.errorsObject.failedToReceiveMainTheme = this.errors.includes('FailedToReceiveMainTheme');
    this.errorsObject.failedToReceiveThemeLiquid = this.errors.includes('FailedToReceiveThemeLiquid');
    this.errorsObject.failedToReceiveProductLiquid = this.errors.includes('FailedToReceiveProductLiquid');
    this.errorsObject.invalidThemeLiquid = this.errors.includes('InvalidThemeLiquid');
    this.errorsObject.yotpoAlreadyInstalled = this.errors.includes('YotpoAlreadyInstalled');
    this.errorsObject.scriptTagInstalled = this.errors.includes('ScriptTagInstalled');
    this.errorsObject.noScriptTagPermissions = this.errors.includes('NoScriptTagPermissions');
  }

  getErrors(): any {
    return Object.keys(this.errorsObject)
      .filter((key) => this.errorsObject[key]);
  }
}
